import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { initPendo } from './utils';

const Pendo = () => {
  const { variables } = useSelector((state) => state.issuerConfiguration);
  const { user } = useSelector((state) => state.auth);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (variables['pendo-enabled'] === 'true' && user && !isInitialized) {
      setIsInitialized(true);
      initPendo(variables['pendo-api-key'], user.investorId);
    }
  }, [user, variables]);

  return <span />;
};

export default Pendo;
